<script>
  import { onMount } from 'svelte';

  import { navigationStore } from '../../stores';

  import Footer from "../../views/Footer.svelte";
  import Headline from "./Headline.svelte";
  import FAQ from "./FAQ.svelte";


  onMount(async () => {
    const hash = $navigationStore.to.hash;

    if (hash) {
      const elm = document.getElementById(hash.replace('#', ''));

      if (elm) {
        setTimeout(() => elm.scrollIntoViewIfNeeded(true), 500);
      }
    }
  });
</script>

<style lang="scss">
  .support {
    height: 100%;
  }
</style>

<section class="support">
  <Headline />
  <FAQ />
  <Footer />
</section>
